import React, { useEffect, useMemo, useState } from "react";
import "./styles.css";
import { Sheet } from "../../Templates";
import { Spinner } from "@chakra-ui/react";
import { MODULE_TYPES, WIDGET_TYPES } from "../../Library/widgets";
import { getDealersAndDevices, getOemAndDealershipDevices } from "../../APIs";
import { DRAWER_ACCESS_CODES } from "../../Library/constants";
import PATHS from "../../Routes/paths";

const DealersOverview = () => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ statistics, setStatistics ] = useState(null);
  const [ dashboardLayout, setDashboardLayout ] = useState([]);

  const ACCESS_CODES = useMemo(() => JSON.parse(window.localStorage.getItem("accessCodes")), []);

  const createOEMCharts = () => {
    getOemAndDealershipDevices((err, data) => {
      if (err) {
        console.error(err);
        setStatistics({});
        setIsLoading(false);
      } else {
        let makeCounts = {};
        let uniqueMakes = new Set();
        let dealershipDevices = {};

        if (data.oemDevs && data.oemDevs.length) {
          data.oemDevs.forEach((device, idx) => {
            makeCounts[device.mk] = (makeCounts[device.mk] || 0) + device.cnt;
            const oem = data.makes.find(make => make.idx === device.mk);
            device.oem = (oem && oem.nm) || "-";
            device.idx = idx + 1;

            if (!uniqueMakes.has(device.mk)) uniqueMakes.add(device.mk);

            if (device.mk) {
              if (dealershipDevices[device.mk]) dealershipDevices[device.mk].push(device);
              else dealershipDevices[device.mk] = [device];
            }
          });

          let makeDeviceList = Array.from(uniqueMakes).map(make => ({
            cnt: makeCounts[make],
            mk: make,
            nm: data.oemDevs.find(device => device.mk === make).nm,
          })).sort((a, b) => b.cnt - a.cnt);

          let topMakes = makeDeviceList.slice(0, 3);
          while (topMakes.length < 3) {
            topMakes.push({});
          }

          let processDevices = (devices) => {
            if (devices.length > 5) {
              devices.sort((a, b) => b.cnt - a.cnt);
              let totalCnt = devices.slice(5).reduce((sum, dev) => sum + dev.cnt, 0);
              devices = devices.slice(0, 5);
              devices.push({
                cnt: totalCnt,
                mk: devices[4].mk,
                nm: 'Other'
              });
            }
            return devices;
          };

          let topOne = processDevices(dealershipDevices[topMakes[0].mk] || []);
          let topTwo = processDevices(dealershipDevices[topMakes[1].mk] || []);
          let topThree = processDevices(dealershipDevices[topMakes[2].mk] || []);

          setStatistics({
            [MODULE_TYPES.ALL_DEVICES]: {
              one: topOne,
              two: topTwo,
              three: topThree,
            },
          });
          setIsLoading(false);
        }
      }
    });
  }

  const createDealershipCharts = () => {
    getDealersAndDevices(null, (err, data) => {
      if (err) {
        console.error(err);
      } else {
        const MAX_CHART_ELEMS = 6;
        let statistics = data;

        let processDevices = (devices) => {
          devices = devices.sort((a, b) => (b.stock + b.installed) - (a.stock + a.installed));
          let processedArr = [];
          if (devices.length > 6) {
            let othersTotalStock = 0;
            let othersTotalInstalled = 0;
            devices.forEach((dev, idx) => {
              if ((idx + 1) < MAX_CHART_ELEMS) {
                processedArr.push(dev);
              } else {
                othersTotalStock += dev.stock;
                othersTotalInstalled += dev.installed;
                if (idx === devices.length - 1) {
                  processedArr.push({ idx: -1, nm: "Others", stock: othersTotalStock, installed: othersTotalInstalled });
                }
              }
            });
            return processedArr;
          }
          return devices;
        };

        let stock = processDevices(statistics);
        let installed = processDevices(statistics);

        stock = stock.map(dev => {
          return { ...dev, count: dev.stock };
        });

        installed = installed.map(dev => {
          return { ...dev, count: dev.installed };
        });

        let arr = [];
        for (let i = 0; i < (stock.length || installed.length); i++) {
          let total = (stock[i] && stock[i].stock ? stock[i].stock : 0) + (installed[i] && installed[i].installed ? installed[i].installed : 0);
          arr.push({ idx: (stock[i] || installed[i]).idx, nm: (stock[i] || installed[i]).nm, count: total });
        }

        setStatistics({ [MODULE_TYPES.ALL_DEVICES]: { stock: stock, installed: installed, total: arr } });
      }

      setIsLoading(false);
    });
  }

  useEffect(() => {
    const DEALERS_DASHBOARD_LAYOUT = [];
    if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.DEALER_MANAGEMENT)) {
        DEALERS_DASHBOARD_LAYOUT.push([WIDGET_TYPES.ALL_DEVICES]);

        if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.ORDERS_OVERVIEW)) { // need last order and wallet in same row
            DEALERS_DASHBOARD_LAYOUT.unshift([WIDGET_TYPES.WALLET, WIDGET_TYPES.LAST_ORDER]);
        }
    } else if (ACCESS_CODES.includes(401)) {
        DEALERS_DASHBOARD_LAYOUT.unshift([WIDGET_TYPES.LAST_ORDER]);
    }

    if (DEALERS_DASHBOARD_LAYOUT.length) setDashboardLayout(DEALERS_DASHBOARD_LAYOUT);

    // createDealershipCharts();
    createOEMCharts();
  }, [ ACCESS_CODES ]);


  return (
    <section className="panel-main seller-dashboard">
      <main>
        {(!isLoading && statistics) ? <Sheet btnOn={0} btnPath={`${PATHS.DEALERS_OVERVIEW}${PATHS.ORDERS_OVERVIEW}`} btnClass={"overview-reports-btn"} layout={dashboardLayout} data={statistics} viewBtnText="View All Order"/> : (
          <div className="widget-loader">
            <Spinner />
          </div>
        )}
      </main>
    </section>
  )
}

export default DealersOverview
